// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2RkH2","label":"Radio_label__1C7FQ","checkMark":"Radio_checkMark__ZkrMf","disabled":"Radio_disabled__1VcsD"};